import { render, staticRenderFns } from "./TheAddCategoryModal.vue?vue&type=template&id=1a517fe4&"
import script from "./TheAddCategoryModal.vue?vue&type=script&lang=js&"
export * from "./TheAddCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./TheAddCategoryModal.vue?vue&type=style&index=0&id=1a517fe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports